export default "__VITE_ASSET__Ci4upOOF__"